/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactElement, useMemo, useState } from 'react';

import { toast } from 'react-toastify';

import { Layout } from '~/components';
import DownloadReports from '~/components/DownloadReportsModal';
import { useLoading } from '~/hooks/loading';
import { ReportsService } from '~/services';

import * as S from './styles';

interface IReportItem {
  label: string;
  reportFileName: string;
}

function Reports(): ReactElement {
  const { setLoading } = useLoading();
  const [
    downloadReportsModalVisible,
    setDownloadReportsModalVisible,
  ] = useState(false);

  const handleDownloadReport = async (reportFileName: string) => {
    try {
      if (reportFileName === 'IB_relatorio_de_alunos') {
        setDownloadReportsModalVisible((prevState) => !prevState);
      } else {
        setLoading(true);
        const response = await ReportsService.getReportProfessionals();
        const link = document.createElement('a');
        link.target = '_blank';
        link.download = `IB_relatorio_de_treinadores`;
        link.href = URL.createObjectURL(response.data);
        link.click();
        toast.success('Relatório baixado.');
        setLoading(false);
      }
    } catch (err: any) {
      setLoading(false);
      console.log(err);
      toast.error('Houve um erro ao baixar o relatório.');
    }
  };

  const ReportsMenuMemo = useMemo(() => {
    const reportsItens: IReportItem[] = [
      {
        label: 'Alunos',
        reportFileName: 'IB_relatorio_de_alunos',
      },
      {
        label: 'Treinadores',
        reportFileName: 'IB_relatorio_de_treinadores',
      },
    ];

    return reportsItens.map((report) => (
      <S.MenuItem key={report.label}>
        <S.MenuLink onClick={() => handleDownloadReport(report.reportFileName)}>
          {report.label}
        </S.MenuLink>
      </S.MenuItem>
    ));
  }, [handleDownloadReport]);

  return (
    <Layout title="Relatórios">
      <S.Container>
        <S.Menu>{ReportsMenuMemo}</S.Menu>
      </S.Container>
      <DownloadReports
        modalIsVisible={downloadReportsModalVisible}
        setModalIsVisible={() =>
          setDownloadReportsModalVisible((prevState) => !prevState)
        }
      />
    </Layout>
  );
}

export default Reports;
